// PrintHandler.jsx
import React from 'react';
import PropTypes from 'prop-types';

export default class PrintHandler extends React.Component {
  static propTypes = {
    copyStyles: PropTypes.bool,
    trigger: PropTypes.func.isRequired,
    content: PropTypes.func.isRequired,
    onBeforePrint: PropTypes.func,
    onAfterPrint: PropTypes.func,
  };

  static defaultProps = {
    copyStyles: true,
  };

  handlePrint = () => {
    const {
      content,
      copyStyles,
      onAfterPrint,
    } = this.props;

    const printWindow = window.open('', 'Print', 'status=no, toolbar=no, scrollbars=yes');

    if (onAfterPrint) {
      printWindow.onbeforeunload = onAfterPrint;
    }

    const contentEl = content();
    const contentNode = contentEl;

    if (!contentNode) return;

    const imageNodes = [...contentNode.getElementsByTagName('img')];
    const linkNodes = document.querySelectorAll('link[rel="stylesheet"]');

    this.imageTotal = imageNodes.length;
    this.imageLoaded = 0;
    this.linkTotal = linkNodes.length;
    this.linkLoaded = 0;

    const markLoaded = (type) => {
      if (type === 'image') this.imageLoaded += 1;
      else if (type === 'link') this.linkLoaded += 1;

      if (this.imageLoaded === this.imageTotal && this.linkLoaded === this.linkTotal) {
        this.triggerPrint(printWindow);
      }
    };

    imageNodes.forEach((img) => {
      const image = img;
      if (/^data:/.test(img.src)) image.crossOrigin = 'anonymous';
      image.setAttribute('src', img.src);
      image.onload = markLoaded.bind(null, 'image');
      image.onerror = markLoaded.bind(null, 'image');
      image.crossOrigin = 'use-credentials';
    });

    if (copyStyles !== false) {
      const headEls = document.querySelectorAll('style, link[rel="stylesheet"]');
      headEls.forEach(node => {
        const newHeadEl = printWindow.document.createElement(node.tagName);

        if (node.textContent) newHeadEl.textContent = node.textContent;
        else if (node.innerText) newHeadEl.innerText = node.innerText;

        [...node.attributes].forEach(attr => {
          let { nodeValue } = attr;

          if (attr.nodeName === 'href' && !/^https?:\/\//.test(attr.nodeValue)) {
            nodeValue = `${document.location.protocol}//${document.location.host}${nodeValue}`;
          }

          newHeadEl.setAttribute(attr.nodeName, nodeValue);
        });

        if (node.tagName === 'LINK') {
          newHeadEl.onload = markLoaded.bind(null, 'link');
          newHeadEl.onerror = markLoaded.bind(null, 'link');
        }

        printWindow.document.head.appendChild(newHeadEl);
      });
    }

    if (document.body.className) {
      document.body.className.split(' ').forEach(cls => {
        if (cls) printWindow.document.body.classList.add(cls);
      });
    }

    const styleEl = printWindow.document.createElement('style');
    styleEl.appendChild(printWindow.document.createTextNode(`
      @page { size: auto; margin: 0mm; }
      @media print { body { -webkit-print-color-adjust: exact; } }
    `));
    printWindow.document.head.appendChild(styleEl);

    printWindow.document.body.innerHTML = contentNode.outerHTML;

    if (this.imageTotal === 0 || copyStyles === false) {
      this.triggerPrint(printWindow);
    }
  };

  triggerPrint(target) {
    const { onBeforePrint } = this.props;
    if (onBeforePrint) onBeforePrint();

    setTimeout(() => {
      target.print();
      target.close();
    }, 500);
  }

  render() {
    const { trigger } = this.props;
    return React.cloneElement(trigger(), {
      ref: (ref) => { this.triggerRef = ref; },
      onClick: this.handlePrint,
    });
  }
}
